/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type SubscriptionPackage,
    SubscriptionPackageFromJSON,
    SubscriptionPackageToJSON,
} from '../models/SubscriptionPackage';
import {
    type SubscriptionPackageAdminData,
    SubscriptionPackageAdminDataFromJSON,
    SubscriptionPackageAdminDataToJSON,
} from '../models/SubscriptionPackageAdminData';
import {
    type SubscriptionPackageProjectData,
    SubscriptionPackageProjectDataFromJSON,
    SubscriptionPackageProjectDataToJSON,
} from '../models/SubscriptionPackageProjectData';
import {
    type SubscriptionPackageUpdateData,
    SubscriptionPackageUpdateDataFromJSON,
    SubscriptionPackageUpdateDataToJSON,
} from '../models/SubscriptionPackageUpdateData';
import {
    type SubscriptionPaymentAdminOverviewData,
    SubscriptionPaymentAdminOverviewDataFromJSON,
    SubscriptionPaymentAdminOverviewDataToJSON,
} from '../models/SubscriptionPaymentAdminOverviewData';

export interface CreateAdminSubscriptionPackageRequest {
    subscriptionPackageUpdateData: SubscriptionPackageUpdateData;
}

export interface DeleteAdminSubscriptionPackageRequest {
    packageId: string;
}

export interface UpdateAdminSubscriptionPackageRequest {
    packageId: string;
    subscriptionPackageUpdateData: SubscriptionPackageUpdateData;
}

/**
 * 
 */
export class AdministrationApi extends runtime.BaseAPI {

    /**
     * Creates request options for createAdminSubscriptionPackage without sending the request
     */
    async createAdminSubscriptionPackageRequestOpts(requestParameters: CreateAdminSubscriptionPackageRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['subscriptionPackageUpdateData'] == null) {
            throw new runtime.RequiredError(
                'subscriptionPackageUpdateData',
                'Required parameter "subscriptionPackageUpdateData" was null or undefined when calling createAdminSubscriptionPackage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/admin/subscription-packages`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SubscriptionPackageUpdateDataToJSON(requestParameters['subscriptionPackageUpdateData']),
        };
    }

    /**
     */
    async createAdminSubscriptionPackageRaw(requestParameters: CreateAdminSubscriptionPackageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubscriptionPackage>> {
        const requestOptions = await this.createAdminSubscriptionPackageRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubscriptionPackageFromJSON(jsonValue));
    }

    /**
     */
    async createAdminSubscriptionPackage(requestParameters: CreateAdminSubscriptionPackageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubscriptionPackage> {
        const response = await this.createAdminSubscriptionPackageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteAdminSubscriptionPackage without sending the request
     */
    async deleteAdminSubscriptionPackageRequestOpts(requestParameters: DeleteAdminSubscriptionPackageRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['packageId'] == null) {
            throw new runtime.RequiredError(
                'packageId',
                'Required parameter "packageId" was null or undefined when calling deleteAdminSubscriptionPackage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/admin/subscription-packages/{packageId}`;
        urlPath = urlPath.replace('{packageId}', encodeURIComponent(String(requestParameters['packageId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteAdminSubscriptionPackageRaw(requestParameters: DeleteAdminSubscriptionPackageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteAdminSubscriptionPackageRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteAdminSubscriptionPackage(requestParameters: DeleteAdminSubscriptionPackageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAdminSubscriptionPackageRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for listAdminSubscriptionPackages without sending the request
     */
    async listAdminSubscriptionPackagesRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/admin/subscription-packages`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async listAdminSubscriptionPackagesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SubscriptionPackageAdminData>>> {
        const requestOptions = await this.listAdminSubscriptionPackagesRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SubscriptionPackageAdminDataFromJSON));
    }

    /**
     */
    async listAdminSubscriptionPackages(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SubscriptionPackageAdminData>> {
        const response = await this.listAdminSubscriptionPackagesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listAdminSubscriptionPayments without sending the request
     */
    async listAdminSubscriptionPaymentsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/admin/subscription-payments`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async listAdminSubscriptionPaymentsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubscriptionPaymentAdminOverviewData>> {
        const requestOptions = await this.listAdminSubscriptionPaymentsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubscriptionPaymentAdminOverviewDataFromJSON(jsonValue));
    }

    /**
     */
    async listAdminSubscriptionPayments(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubscriptionPaymentAdminOverviewData> {
        const response = await this.listAdminSubscriptionPaymentsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listSubscriptionPackageProjects without sending the request
     */
    async listSubscriptionPackageProjectsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/admin/subscription-package-projects`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async listSubscriptionPackageProjectsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SubscriptionPackageProjectData>>> {
        const requestOptions = await this.listSubscriptionPackageProjectsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SubscriptionPackageProjectDataFromJSON));
    }

    /**
     */
    async listSubscriptionPackageProjects(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SubscriptionPackageProjectData>> {
        const response = await this.listSubscriptionPackageProjectsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateAdminSubscriptionPackage without sending the request
     */
    async updateAdminSubscriptionPackageRequestOpts(requestParameters: UpdateAdminSubscriptionPackageRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['packageId'] == null) {
            throw new runtime.RequiredError(
                'packageId',
                'Required parameter "packageId" was null or undefined when calling updateAdminSubscriptionPackage().'
            );
        }

        if (requestParameters['subscriptionPackageUpdateData'] == null) {
            throw new runtime.RequiredError(
                'subscriptionPackageUpdateData',
                'Required parameter "subscriptionPackageUpdateData" was null or undefined when calling updateAdminSubscriptionPackage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/admin/subscription-packages/{packageId}`;
        urlPath = urlPath.replace('{packageId}', encodeURIComponent(String(requestParameters['packageId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SubscriptionPackageUpdateDataToJSON(requestParameters['subscriptionPackageUpdateData']),
        };
    }

    /**
     */
    async updateAdminSubscriptionPackageRaw(requestParameters: UpdateAdminSubscriptionPackageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubscriptionPackage>> {
        const requestOptions = await this.updateAdminSubscriptionPackageRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubscriptionPackageFromJSON(jsonValue));
    }

    /**
     */
    async updateAdminSubscriptionPackage(requestParameters: UpdateAdminSubscriptionPackageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubscriptionPackage> {
        const response = await this.updateAdminSubscriptionPackageRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
